module.exports = __webpack_public_path__ + "img/查看更多.babf5ed6.png";